import React, { useContext, useState, useEffect } from "react";
import "./../../../../font.css";
import { kioskstyles } from "./../../../../kioskstyles";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../../env");

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function VersionDisplay(props) {
  const [versionMismatch, setVersionMismatch] = useState(false);
  const [newVerison, setNewVerison] = useState("");

  const { getKioskConfiguration } = useContext(SocketIOContext);

  useEffect(() => {
    const kioskConfiguration = getKioskConfiguration();

    //if kioskConfiguration is not configured goto error
    if (
      kioskConfiguration !== null &&
      kioskConfiguration?.currentVersion !== env.REACT_APP_VERSION
    ) {
      setVersionMismatch(true);
      setNewVerison(kioskConfiguration?.currentVersion);
    } else {
      setVersionMismatch(false);
      setNewVerison("");
    }
  }, [getKioskConfiguration]);

  return (
    //These Style should match the styles form the idle timer
    <div
      style={{
        position: "absolute",
        bottom: "1vh",
        left: "1vw",
        color: "white",
        display: "flex"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "parent",
          fontSize: "clamp(12px, 2.5vh, 100px)"
        }}
      >
        {/* Idle: */}
      </div>
      <div
        id="appVersionDiv"
        class="fontSecondaryText"
        style={{
          marginLeft: "1vh",
          width: "clamp(2.25px, 10vh, 200px)",
          height: "clamp(2.25px, 5vh, 100px)",
          fontSize: "clamp(1.5px, 2.5vh, 100px)"
          //borderRadius: "50px"
          //backgroundColor: "white"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            height: "100%",
            textAlign: "left"
          }}
        >
          <span style={{ color: "white" }}>{env.REACT_APP_VERSION}</span>
          {versionMismatch && <span>→{newVerison}</span>}
        </div>
      </div>
    </div>
  );
}

//Depricated
export default VersionDisplay;
